import { action, ActionType } from 'typesafe-actions';
import {
  // @translate
  Stocks_StockType,
  // @translate
  Stocks_StockRisk,
} from '../../../__generated__/globalTypes';
import { SortDirection } from 'types/common';
import { Range } from './consts';

export const CHANGE_NAME = 'STOCKS_FILTER/CHANGE_NAME';
export const CHANGE_SECTOR = 'STOCKS_FILTER/CHANGE_SECTOR';
export const CHANGE_INDUSTRY = 'STOCKS_FILTER/CHANGE_INDUSTRY';
export const CHANGE_TYPE = 'STOCKS_FILTER/CHANGE_TYPE';
export const CHANGE_CAPRANGE = 'STOCKS_FILTER/CHANGE_CAPRANGE';
export const CHANGE_RISK = 'STOCKS_FILTER/CHANGE_RISK';
export const CHANGE_PRICE_CHANGE_PERIOD = 'STOCKS_FILTER/CHANGE_PRICE_CHANGE_PERIOD';
export const CHANGE_PRICE = 'STOCK_FILTER/CHANGE_PRICE';
export const SORT = 'STOCKS_FILTER/SORT';
export const RESET = 'STOCKS_FILTER/RESET';

export type SortableFields = 'capitalization' | 'name' | 'risk' | 'priceChange' | 'price';

export const actions = {
  changeName: (name?: string) => action(CHANGE_NAME, { name }),
  changeSector: (name: string) => action(CHANGE_SECTOR, { name }),
  changeIndustry: (name: string) => action(CHANGE_INDUSTRY, { name }),
  changeType: (type: Stocks_StockType) => action(CHANGE_TYPE, { type }),
  changeCapRange: (range: Range) => action(CHANGE_CAPRANGE, { range }),
  changeRisk: (risk?: Stocks_StockRisk) => action(CHANGE_RISK, { risk }),
  changePriceChangePeriod: (period: number) => action(CHANGE_PRICE_CHANGE_PERIOD, { period }),
  changePrice: (price: number) => action(CHANGE_PRICE, { price }),
  reset: () => action(RESET),
  sort: (field: SortableFields, direction: SortDirection) => action(SORT, { field, direction }),
};

export type Action = ActionType<typeof actions>;
